import {VivoPortal} from "@utils/AppConstants";
import EnumIconButtonDefaultType = VivoPortal.EnumIconButtonDefaultType;
import {FontAwesomeIcon, FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {IconDefinition} from "@fortawesome/free-regular-svg-icons";

export default function FlintIcon(props: FlintIconProps) {

    const {utils} = useFlintIcon(props);
    const {iconEnum, className = "m-0 p-0", ...other} = props;
    return <FontAwesomeIcon icon={utils.iconDef} className={className} {...other} />
}

export interface FlintIconProps {
    iconEnum?: EnumIconButtonDefaultType;
    className? : string;
}

function useFlintIcon(props: FlintIconProps) {
    let iconDef : IconDefinition = icons.faEye;
    switch (props.iconEnum) {
        case EnumIconButtonDefaultType.Delete:
            iconDef = icons.faTrash;
            break;
        case EnumIconButtonDefaultType.Edit:
            iconDef = icons.faEdit;
            break;
        case EnumIconButtonDefaultType.Preview:
            iconDef = icons.faEye;
            break;
        case EnumIconButtonDefaultType.Download:
            iconDef = icons.faDownload;
            break;
        case EnumIconButtonDefaultType.InternalUrl:
            iconDef = icons.faLink;
            break;
        case EnumIconButtonDefaultType.ExternalUrl:
            iconDef = icons.faExternalLink;
            break;
        case EnumIconButtonDefaultType.Print:
            iconDef = icons.faPrint;
            break;
        case EnumIconButtonDefaultType.UnDelete:
            iconDef = icons.faTrashRestore;
            break;
        case EnumIconButtonDefaultType.Save:
            iconDef = icons.faSave;
            break;
        case EnumIconButtonDefaultType.Cancel:
            iconDef = icons.faCancel;
            break;
        case EnumIconButtonDefaultType.Select:
            iconDef = icons.faCheck;
            break;
        case EnumIconButtonDefaultType.Copy:
            iconDef = icons.faCopy;
            break;
        case EnumIconButtonDefaultType.Unlocked:
            iconDef = icons.faLockOpen;
            break;
        case EnumIconButtonDefaultType.Locked:
            iconDef = icons.faLock;
            break;
        case EnumIconButtonDefaultType.Plus:
            iconDef = icons.faPlus;
            break;
        case EnumIconButtonDefaultType.Return:
            iconDef = icons.faReply;
            break;
        case EnumIconButtonDefaultType.Pdf:
            iconDef = icons.faFilePdf;
            break;
        case EnumIconButtonDefaultType.Accept:
            iconDef = icons.faCheck;
            break;
        case EnumIconButtonDefaultType.Apply:
            iconDef = icons.faPaperPlane;
            break;
        case EnumIconButtonDefaultType.Image:
            iconDef = icons.faImage;
            break;
        case EnumIconButtonDefaultType.Excel:
            iconDef = icons.faFileExcel;
            break;
        case EnumIconButtonDefaultType.Csv:
            iconDef = icons.faFileCsv;
            break;
        case EnumIconButtonDefaultType.ThumbUp:
            iconDef = icons.faThumbsUp;
            break;
        case EnumIconButtonDefaultType.ThumbDown:
            iconDef = icons.faThumbsDown;
            break;
        case EnumIconButtonDefaultType.Order:
            iconDef = icons.faFileInvoice;
            break;
        default:
            iconDef = icons.faEye;
            break;
    }
    return {
        utils: {
            iconDef,
        }

    }
}